(() => {
  document.querySelectorAll('[data-dap-share-url]').forEach(button => {
    button.hidden = false;
    button.addEventListener('click', async () => {
      const url = new URL(button.dataset.dapShareUrl, location.origin);
      const selectedVariant = button.closest('[data-dap-product-root]')?.querySelector('.dap-product-form [name="id"]')?.value;
      if (/^\d+$/.test(selectedVariant || '')) url.searchParams.set('variant', selectedVariant);
      const data = {title:button.dataset.shareTitle,url:url.href};
      const output = button.parentElement.querySelector('[data-product-share-status]');
      try { if (navigator.share) { await navigator.share(data); return; } } catch(e) { if (e.name === 'AbortError') return; }
      try { await navigator.clipboard.writeText(data.url); output.textContent = 'Product link copied. Ready to share.'; }
      catch { output.textContent = data.url; }
    });
  });
  const dialog = document.querySelector('[data-art-viewer]');
  if (!dialog || !dialog.showModal || dialog.dataset.bound) return;
  dialog.dataset.bound = 'true';
  const image = dialog.querySelector('[data-viewer-image]');
  const title = dialog.querySelector('#ArtViewerTitle');
  const status = dialog.querySelector('[data-viewer-status]');
  const error = dialog.querySelector('[data-viewer-image-error]');
  const shop = dialog.querySelector('[data-viewer-shop]');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let items = [], index = 0, opener, scrollOverflow = '', openingAnimation;
  const enable = (scope = document) => scope.querySelectorAll('[data-dap-art-view]').forEach(b => { if (b.dataset.artSrc && b.dataset.artUrl) b.hidden = false; });
  enable();
  document.addEventListener('shopify:section:load', event => enable(event.target));
  document.addEventListener('dap:collection:updated', () => enable());
  const draw = () => {
    const data = items[index].dataset;
    image.hidden = false; error.hidden = true; status.textContent = '';
    dialog.querySelector('[data-viewer-share-url]').hidden = true;
    image.alt = data.artTitle;
    image.src = data.artSrc;
    title.textContent = data.artTitle;
    dialog.querySelector('[data-viewer-price]').textContent = data.artPrice;
    shop.href = data.artUrl;
    dialog.querySelector('[data-viewer-count]').textContent = `${index + 1} / ${items.length}`;
    dialog.querySelector('[data-viewer-prev]').disabled = index === 0;
    dialog.querySelector('[data-viewer-next]').disabled = index === items.length - 1;
  };
  image.addEventListener('error', () => { image.hidden = true; error.hidden = false; });
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-dap-art-view]');
    if (!button || !button.dataset.artSrc) return;
    const scope = button.closest('[data-dap-exhibition], [data-dap-collection-discovery], .dap-featured, main') || document;
    const seen = new Set();
    items = [...scope.querySelectorAll('[data-dap-art-view]')].filter(b => {
      if (!b.getClientRects().length || seen.has(b.dataset.artUrl)) return false;
      seen.add(b.dataset.artUrl); return true;
    });
    index = items.indexOf(button); if (index < 0) { items = [button]; index = 0; }
    opener = button;
    document.querySelectorAll('[data-dap-living-art]').forEach(a => a.dispatchEvent(new CustomEvent('dap:living-art:reset', { bubbles: true })));
    draw();
    scrollOverflow = document.documentElement.style.overflow;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    dialog.querySelector('[data-viewer-close]').focus({preventScroll:true});
    if (!reduced.matches && dialog.animate) {
      const source = button.closest('article')?.querySelector('img')?.getBoundingClientRect();
      if (source) {
        const target = image.getBoundingClientRect();
        const scale = Math.min(source.width / Math.max(target.width, 1), source.height / Math.max(target.height, 1));
        openingAnimation = image.animate([{transform:`translate(${source.x + source.width / 2 - target.x - target.width / 2}px,${source.y + source.height / 2 - target.y - target.height / 2}px) scale(${scale})`},{transform:'none'}],{duration:430,easing:'cubic-bezier(.16,1,.3,1)'});
      }
    }
  });
  const step = delta => { const next = index + delta; if (next < 0 || next >= items.length) return; openingAnimation?.cancel(); index = next; draw(); };
  dialog.querySelector('[data-viewer-close]').addEventListener('click', () => dialog.close());
  dialog.querySelector('[data-viewer-prev]').addEventListener('click', () => step(-1));
  dialog.querySelector('[data-viewer-next]').addEventListener('click', () => step(1));
  dialog.addEventListener('keydown', event => { if (event.target.matches('input')) return; if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); step(event.key === 'ArrowRight' ? 1 : -1); } });
  dialog.addEventListener('click', event => { if (event.target !== dialog) return; const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); });
  dialog.addEventListener('close', () => { openingAnimation?.cancel(); document.documentElement.style.overflow = scrollOverflow; image.removeAttribute('src'); opener?.focus({preventScroll:true}); });
  dialog.querySelector('[data-viewer-share]').addEventListener('click', async () => {
    const data = {title: title.textContent, url: new URL(shop.getAttribute('href'), location.origin).href};
    try { if (navigator.share) { await navigator.share(data); return; } } catch (e) { if (e.name === 'AbortError') return; }
    try { await navigator.clipboard.writeText(data.url); status.textContent = 'Product link copied. Ready to share.'; }
    catch { const input = dialog.querySelector('[data-viewer-share-url]'); input.value = data.url; input.hidden = false; input.focus(); input.select(); status.textContent = 'Copy this product link to share it.'; }
  });
})();
